module.exports = __webpack_public_path__ + "media/images/pic/hero/buildings-7d7d33ee3b310435879beac76be43c1e.png";